module.exports = __webpack_public_path__ + "img/ramp.fa1ecce4.png";